export default class QuickQuoteFlowHealth {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'quickquote-health-info-submit-ok':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger submit ok',
                    'eventLabel': 'Submit ok',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-insured-adult':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger - forsikringstager',
                    'eventLabel': 'Migselv',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-insured-child':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger - forsikringstager',
                    'eventLabel': 'Mit barn',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-already-insured':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger - allerede forsikret',
                    'eventLabel': 'ja',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-not-insured':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger - allerede forsikret',
                    'eventLabel': 'nej',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-add-to-basket':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '02 vælg dækning læg i kurv',
                    'eventLabel': 'Læg i kurv',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-add-child-to-basket':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '02 vælg dækning om dit barn',
                    'eventLabel': 'Læg i kurv',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-add-to-basket-error':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '02 vælg dækning error',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-popup-view':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger - infoboks impression',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-popup-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '01 oplysninger - infoboks klik',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-checkout-not-insured':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '04 supplerende oplysninger - opsige anden forsikring',
                    'eventLabel': 'nej',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-checkout-already-insured':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '04 supplerende oplysninger - opsige anden forsikring',
                    'eventLabel': 'ja',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-checkout-insured-self':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '04 supplerende oplysninger - tilhørsforhold anden forsikring',
                    'eventLabel': 'I mit navn',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-checkout-insured-partner':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '04 supplerende oplysninger - tilhørsforhold anden forsikring',
                    'eventLabel': 'I min samlevers navn',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'quickquote-health-checkout-insured-joint':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'sundhed prisberegner',
                    'eventAction': '04 supplerende oplysninger - tilhørsforhold anden forsikring',
                    'eventLabel': 'I mit og samlevers navn',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
        }
        return trackingObject;
    }
}
